import React, { Fragment, useState, useEffect } from 'react';
import PopUp from '../container';

import Button from "../../components/button";
import TextField from "../../components/textfield";

import "./company_info.scss";
import useGlobal from '../../../store';
import cssIf from '../../../scripts/helpers/class.add.if';
import generatePassword from '../../../scripts/helpers/generate.password';
import { APP_URL } from '../../../settings/host';
import textToTranslit from '../../../scripts/helpers/text.to.translit';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ru } from 'date-fns/locale/ru';
import twoDigitFormat from '../../../scripts/helpers/two.digit.format';
registerLocale( 'ru', ru );

const CompanyInfoPopUp = () => {

  const [ Popup, showPopup, hidePopup ] = PopUp();

  const [ globalState, globalActions ] = useGlobal();
  const { user } = globalState;
  const { users } = globalActions;

  const [company, setCompany] = useState("");
  const [subscribeEndDate, setSubscribeEndDate] = useState(new Date());

  const [comment, setComment] = useState("");
  const [fullname, setFullname] = useState("");
  const [phone, setPhone] = useState("");
  const [mail, setMail] = useState("");
  const [pass, setPass] = useState("");
  const [editAcessDate, setEditAcessDate] = useState( false );

  const [ isPasswordResetted, setIsPasswordResetted ] = useState( false );    

  const editMode = +globalState.user.id > 0;
  const isEmailOrPasswordChanged = isPasswordResetted || mail !== globalState.user.email;

  useEffect(() => {

    if ( editMode ) {

      setCompany( globalState.user.company_name );
      setComment( globalState.user.comment );
      setFullname( globalState.user.fio );
      setMail( globalState.user.email );
      setPhone( globalState.user.phone );
      setSubscribeEndDate( new Date( globalState.subscribe.dateEnd ));
      setPass(""); // TODO hide pass -> setPassIsHidden -> reset pass

    }

  }, [ globalState.user.id ]);

  function sendData () {

    let popupData = {

      // active: editMode ? globalState.company.active : 1,
      company_name: company,
      comment: comment,
      fio: fullname,
      phone: phone,
      email: mail

    }

    if ( !editMode || isPasswordResetted ) {
      popupData.password = pass
    }

    if ( !editMode || editAcessDate ) {
      popupData.access_date = `${ subscribeEndDate.getFullYear() }-${ twoDigitFormat( subscribeEndDate.getMonth() + 1 ) }-${ twoDigitFormat( subscribeEndDate.getDate() ) }`
    }

    if ( editMode ) { users.changeInfo( globalState.user.id, popupData ); }
    else { users.add( popupData ) }

    hidePopup();

  }
  
  
  const CONTENT = Popup({

    title: `${ cssIf( editMode, "Редактирование", "Добавление" ) } \n компании`,
    withoutPadding: true,
    action: sendData,

    content: (

      <div className="flex company_info">

        <div className="divider__left">

          <p className="montserrat popup-text">Данные компании</p>

          <TextField
          
            type="text"
            title="Название компании:"
            value={ company }
            set = { setCompany }
            
          />

          {( editMode && !editAcessDate )
          
          ? <div 
              className = "react-datepicker__input-container react-datepicker__input-container--text"
              onClick = { () => setEditAcessDate( true ) }
            >

              <p className="access_granted_text">Доступ активен до:</p>

              { twoDigitFormat( subscribeEndDate.getDate() ) }.{ twoDigitFormat( subscribeEndDate.getMonth() + 1 ) }.{ subscribeEndDate.getFullYear() } – нажмите, чтобы изменить

            </div>

          : <div className = "justify-between items-center">

              <p className="access_granted_text">Доступ активен до:</p>

              <DatePicker 
                
                locale = "ru"
                dateFormat="dd.MM.yyyy"
                selected = { subscribeEndDate }
                onChange = { (date) => setSubscribeEndDate(date) }

              />

            </div>
            
          }

          <TextField
          
            type="text"
            title={<Fragment>Комментарий: <span>(необязательно)</span></Fragment>}
            value={ comment }
            set = { setComment }
            isArea={ true }
            rows = { 3 }
            
          />

        </div>

        <div className="divider__right">
              
          <p className="montserrat popup-text">Данные владельца компании</p>

          <TextField
          
            type="text"
            title="ФИО владельца:"
            value={ fullname }
            set = { setFullname }
          
          />

          <TextField
        
            type="number"
            title="Телефон:"
            value={ phone }
            set = { setPhone }
          
          />

          <TextField
        
            title="E-mail:"
            value={ mail }
            set = { setMail }
          
          />

          { ( !editMode || isPasswordResetted ) &&

            <div className="flex relative">

              <TextField

                title="Пароль:"
                value={ pass }
                set = { setPass }

              />

              <Button 

                text="Сгенерировать"
                className="popup__button__generate-pass popup__button__generate-pass__employee popup__button__generate-pass__company"
                action = {() => setPass( generatePassword() )}

              />

            </div>

          }

          {(( editMode && !isPasswordResetted ) ) &&

            <React.Fragment>

              <div className={`textfield textfield-wrapper`}>
                <p className="textfield-wrapper__title">Пароль:</p>
              </div>

              <div 
                className="resetpassword__text"
                onClick={() => { 
                  window.confirm("Вы точно хотите сбросить пароль?") && setIsPasswordResetted( true );
                }}
              >

                Мы не храним пароли в открытом виде.<br/>
                Установить новый пароль вы можете <span>сбросив старый</span>.
                
              </div>

            </React.Fragment>

          }

          {(

            ( !editMode && mail.indexOf('@') !== -1 && mail.indexOf('.') !== -1 && pass.length > 3 && fullname.length > 7 && phone.length > 9 ) 
            || 
            ( editMode && isEmailOrPasswordChanged ) 

            ) &&

            <a 
              href={`mailto:${mail}?body=${ editMode ? "Данные" : "Изменились данные"} для входа в <a href="${ APP_URL }">${ APP_URL }</a>: <br>логин: ${( !editMode || mail !== globalState.user.email ) ? mail : "тот же, что и был"} <br>пароль: ${( !editMode || isPasswordResetted ) ? pass : "тот же, что и был"}&subject=${ !editMode ? "Добро пожаловать" : "Изменились данные для входа" } в ArbitrParser!`}
              rel="norefferer"
              target="_blank"
            >
              <Button

                className="popup__button__generate-pass__send"
                text = {( <Fragment>Отправить <span className="desktop" style = {{ margin: '0 5px' }}>владельцу</span> данные для входа на e-mail</Fragment> )}

              />

            </a>

          }

        </div>

      </div>

    )

  });

	return [

    CONTENT,
    showPopup,
    hidePopup

  ]

}

export default CompanyInfoPopUp;